const ImageTypes = {
  GIF: { mime: 'image/gif', extension: '.gif' },
  JPG: { mime: 'image/jpeg', extension: '.jpg' },
  JPEG: { mime: 'image/jpeg', extension: '.jpeg' },
  PNG: { mime: 'image/png', extension: '.png' },
};

export default ImageTypes;
